import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EventEmitterService {
    private eventEmitters: Map<string, EventEmitter<unknown>> = new Map();

    getEmitter(key: string): EventEmitter<unknown> {
        if (!this.eventEmitters.has(key)) {
            this.eventEmitters.set(key, new EventEmitter<unknown>());
        }

        return this.eventEmitters.get(key) ?? new EventEmitter<unknown>();
    }
}
